export default __webpack_public_path__ + "static/media/bootstrap.abe7ea2f.png";